/**
 * Simple pluralize function that appends an 's' to the word if the count is 1.
 *
 * @param count Count of item
 * @param word Word to potentially pluralize
 * @returns The word pluralized if count is 1, else the word
 */
export function pluralize(count: number, word: string) {
  return count === 1 ? word : `${word}s`;
}
